<template>
  <div :class="$style.item">
    <div :class="$style.title">
      <h2>
        <span v-for="(title, titleIndex) in data.title" :key="titleIndex">
          {{ title }}
        </span>
      </h2>
    </div>
    <div :class="$style.content">
      <div
        v-for="(intro, introIndex) in data.direction"
        :key="introIndex"
        :class="$style.intro"
      >
        <h3 v-if="intro.title">{{ intro.title }}：</h3>
        <p>{{ intro.info }}</p>
      </div>
      <div :class="$style.contact">
        <the-business-item-contact
          v-for="(contact, contactIndex) in data.contact"
          :key="contactIndex"
          :data="contact"
          :class="$style.contact_list"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TheBusinessItemContact from './TheBusinessItemContact'

export default {
  components: { TheBusinessItemContact },
  props: {
    data: {
      type: Object,
      default() {
        return {}
      },
    },
  },
}
</script>

<style lang="less" module>
@border-color: #eaeaea;
@padding: 3.6rem;
@title-left: 1.5rem;
@content-margin-left: 5.11rem;

.item {
  position: relative;
  margin: 0 @padding;
  padding: 0.6rem 0;
  border-bottom: 1px solid @border-color;

  &:first-child {
    border-top: 1px solid @border-color;
  }

  &:global(.active) {
    background-color: #f8f8f8;

    &::before {
      .size(0.04rem, 100%);
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      background-color: @primary;
    }
  }
}

.title {
  position: absolute;
  top: 0.6rem;
  left: @title-left;
  min-height: 0.65rem;
  padding: 0.39rem 0 0 0.27rem;

  h2 {
    z-index: 1;
    position: relative;
    font-weight: 700;
    font-size: 18px;
    line-height: 1.5;

    span {
      display: block;
    }
  }

  &::before {
    .size(0.75rem, 0.62rem);
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    background: url('./images/business-title-badge.png') no-repeat;
    background-size: 400% 100%;

    .loop(@n) when (@n <=4) {
      .item:nth-child(@{n}) & {
        .sprites-position-x(300, 75, 75 * (@n - 1));
      }

      .loop(@n + 1);
    }

    .loop(1);
  }
}

.content {
  margin-left: @content-margin-left;
}

.intro {
  margin-right: 1.12rem;
  line-height: 1.6;

  &:not(:first-child) {
    margin-top: 0.3rem;
  }

  h3 {
    font-weight: 700;
    font-size: 14px;
  }
}

.contact {
  display: flex;
  flex-wrap: wrap;
  margin-top: 0.3rem;
  border-top: 2px solid #e9e9e9;
}

@media screen and (max-width: @tablet-width) {
  @tablet-padding: 1.5; // tablet 适配: 左边距左移 150

  .item {
    margin-left: @padding - @tablet-padding;
  }

  .title {
    left: @title-left - @tablet-padding * 0.6;
  }

  .content {
    margin-left: @content-margin-left - @tablet-padding;
  }
}

@media screen and (max-width: @mini-width) {
  @mini-padding: 3; // mini 适配: 左右各移 300

  .item {
    margin-left: @padding - @mini-padding;
    margin-right: @padding - @mini-padding;
    padding: 1rem 0.5rem;
    font-size: 12px;
  }

  .title {
    position: relative;
    top: 0;
    left: 0;
    margin-bottom: 0.3rem;
    padding: 0;

    &::before {
      content: none;
    }

    h2 {
      font-size: 16px;

      span {
        display: inline;
      }
    }
  }

  .content {
    margin-left: 0;
  }

  .title {
    margin-bottom: 0;
  }

  .intro {
    margin-right: 0;

    &,
    &:not(:first-child) {
      margin-top: 0.8em;
    }
  }

  .contact {
    margin-top: 1.5em;
    padding-top: 2em;
  }
}

@media screen and (max-width: @mobile-width) {
  .contact {
    justify-content: space-between;

    &_list {
      &:last-child:not(:first-child) {
        margin-left: 0;
        padding-right: 2em;
      }
    }
  }
}
</style>
